<template>
  <div style="display: flex; width: 100%; justify-content: flex-start; align-items: center; flex-direction: column">
    <h1>Privacy Policy for Skull King Counter</h1>
    <p>I do not collect any data from you, but google play needs this page anyway, so just enjoy the game</p>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyFree'
}
</script>

<style scoped>

</style>
